import {createGlobalStyle} from 'styled-components';

import 'mapbox-gl/dist/mapbox-gl.css';
import '@mantine/notifications/styles.css';
import '@mantine/core/styles.css';
import '@mantine/spotlight/styles.css';
import '@mantine/dropzone/styles.css';

const GlobalStyle = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    font-family: 'Montserrat', Helvetica, Sans-Serif;
    box-sizing: border-box;
    font-size: 14px;
    text-decoration: none;
  }

  .Toastify__toast-container--top-right {
    background-color: transparent !important;
  }
`;

export default GlobalStyle;
